export const FormEducationENUM = {
  CORRESPONDENCE: 'Заочная',
  CORRESPONDENCE_ELECTRONIC: 'Заочная с применением электронного обучения',
  CORRESPONDENCE_REMOTE: 'Заочная с применением дистанционных технологий',
  ELECTRONIC: 'Электронная',
  FULL_TIME: 'Очная',
  FULL_TIME_ELECTRONIC: 'Очная с применением электронного обучения',
  FULL_TIME_PART_TIME: 'Очно - заочная',
  FULL_TIME_REMOTE: 'Очная с применением дистанционных технологий',
  INTERACTIVE: 'Интерактивная',
  NETWORKING: 'Сетевая',
  PART_TIME:
    'Очно-заочная с применением дистанционных образовательных технологий',
  REMOTE: 'Дистанционная',
}

export const DurationsENUM = {
  MINUTE: 'минут',
  HOUR: 'чаcа',
  DAY: 'дня',
  WEEK: 'недели',
  MONTH: 'месяца',
  YEAR: 'года',
}

export const DeclarationsENUM = {
  minutesDeclaration: ['минута', 'минуты', 'минут'],
  hourDeclaration: ['час', 'часа', 'часов'],
  dayDeclaration: ['день', 'дня', 'дней'],
  weekDeclaration: ['неделя', 'недели', 'недель'],
  monthDeclaration: ['месяц', 'месяца', 'месяцев'],
  yearDeclaration: ['год', 'года', 'лет'],
}
